import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21dadbc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = {
  class: "modal-content rounded",
  style: {"max-height":"500px"}
}
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = ["data-kt-indicator"]
const _hoisted_12 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_13 = { class: "indicator-progress" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: `kt_modal_delete_round_disclaimer_${_ctx.id}`,
    ref: "newTargetModalRef",
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "w-lg-500px bg-white p-10 p-lg-15 mx-auto",
              innerHTML: _ctx.inner
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connect && _ctx.connect(...args))),
                  class: "btn btn-primary my-3 float-end"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Accept"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_13, [
                    _hoisted_14,
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_11)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}